module.exports = __webpack_public_path__ + "img/or.31cb0699.svg";